import { useLayoutEffect } from 'react';
import { SLUG_BY_ID, ID_BY_SLUG } from '../../data/slugs';
import { calculatorContent } from '../../data/calculatorContent';
import { legalDocs } from '../../data/legalContent';
import { canonicalPath, pageSchema, updatePageHead } from '../../lib/pageMetadata';

const STATIC_SLUGS = [...Object.values(SLUG_BY_ID), ...Object.keys(legalDocs)];

export default function SEO({ title, description, path = '/' }) {
  useLayoutEffect(() => {
    const canonical = canonicalPath(path, STATIC_SLUGS);
    const url = 'https://calcglobe.com' + canonical;
    const slug = canonical.replace(/^\/+|\/+$/g, '');
    updatePageHead(document, {
      title, description, url,
      schema: pageSchema(title, url, calculatorContent[ID_BY_SLUG[slug]]),
    });
  }, [title, description, path]);
  return null;
}
